import React, { useEffect, useState } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: '首页',
    href: '#'
  }, {
    name: '伴游女郎',
    href: '#featured'
  }, {
    name: '服务流程',
    href: '#how-it-works'
  }, {
    name: '关于我们',
    href: '#trust'
  }, {
    name: '联系我们',
    href: '#footer'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-dark-900/95 backdrop-blur-md border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-241">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-242">
        <div className="flex justify-between items-center" data-id="element-243">
          {/* Logo */}
          <div className="flex items-center" data-id="element-244">
            <a href="#" className="flex flex-col" data-id="element-245">
              <span className="text-2xl font-serif font-bold text-white tracking-wide" data-id="element-246">
                IsYou <span className="text-gold-500" data-id="element-247">.</span>
              </span>
              <span className="text-[10px] text-gray-400 tracking-[0.2em] uppercase" data-id="element-248">
                新加坡是您网
              </span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-249">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm text-gray-300 hover:text-gold-500 transition-colors uppercase tracking-wider" data-id="element-250">
                {link.name}
              </a>)}
          </div>

          {/* Right Actions */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-251">
            <button className="flex items-center text-gray-300 hover:text-white transition-colors" data-id="element-252">
              <Globe className="w-4 h-4 mr-1" data-id="element-253" />
              <span className="text-xs" data-id="element-254">CN / EN</span>
            </button>
            <button className="px-6 py-2 border border-gold-500 text-gold-500 text-sm hover:bg-gold-500 hover:text-dark-900 transition-all duration-300 uppercase tracking-wider" data-id="element-255">
              立即预约
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-256">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white p-2" data-id="element-257">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-258" /> : <Menu className="w-6 h-6" data-id="element-259" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-260">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-dark-900 border-b border-white/10 overflow-hidden" data-id="element-261">
            <div className="px-4 py-6 space-y-4" data-id="element-262">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block text-gray-300 hover:text-gold-500 text-lg py-2 border-b border-white/5" data-id="element-263">
                  {link.name}
                </a>)}
              <div className="pt-4 flex flex-col space-y-4" data-id="element-264">
                <button className="flex items-center text-gray-300" data-id="element-265">
                  <Globe className="w-4 h-4 mr-2" data-id="element-266" />
                  <span data-id="element-267">切换语言 / Language</span>
                </button>
                <button className="w-full py-3 bg-gold-500 text-dark-900 font-medium uppercase tracking-wider" data-id="element-268">
                  立即预约
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}